export default {
	activeFiltersTooltipLabel: '{activeFilters} filter{pluralExtension} active',
	popoverTrigger: 'Extra filters',
	tooltipLabel: 'Filters',
};
